
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';
import { AbVersaoAppLoja } from 'app/abstract/full-pages/versao-app-loja/versao-app-loja.abstract';

@Injectable({ providedIn: 'root' })
export class VersaoAppLojaService extends AbVersaoAppLoja {

  constructor(http: HttpClient) {
    super(http);
  }

  getVersions(filter: AppFilter): Observable<any> {
    return this.getAll("versao_app_loja/", filter.encode());
  }

  verificar(id: number): Observable<any> {
    return this.get("versao_app_loja/verificar/", id);
  }

  getUrlLoja(id: number, loja: string): Observable<any> {
    return this.get(`versao_app_loja/url/${id}/${loja}`);
  }
}
